import { capitalizeWords } from "../../utils";
import {
  Building2,
  MapPin,
  Clock,
  Briefcase,
  Star,
  PoundSterling,
} from "lucide-react";

const JobCard = ({ job, featured }) => {
  let salary;
  let salaryFrequency =
    job.jobAdvert.jobDetails.salary?.exactAmount?.frequency?.value ?? " - ";
  if (job.jobAdvert.jobDetails.salary.range) {
    salary = `${job.jobAdvert.jobDetails.salary.range.min} - ${job.jobAdvert.jobDetails.salary.range.max}`;
  } else {
    salary = `${job.jobAdvert.jobDetails.salary.exactAmount.amount}`;
  }

  const loadDetailPage = () => {
    let url = `${process.env.REACT_APP_SITE_URL}job/${job._id}`;
    if (job.source === 'BULLHORN') {
      url = `${process.env.REACT_APP_SITE_URL}job/${job.sourceId ?? job._id}`;
    }
    window.open(url, "_blank");
  };
  return (
    <div
      className={`cursor-pointer border rounded p-4 hover:shadow transition-shadow ${featured ? "border-blue-500" : "border-gray-200"}`}
      onClick={loadDetailPage}
    >
      <h3 className="text-lg font-semibold mb-1">
        {job.jobAdvert.basicInfo.jobTitle}
      </h3>
      <span className="flex items-center gap-1">
        <MapPin className="h-3 w-3" />
        {job.jobAdvert.basicInfo.location.details.city}{" "}
        {job.jobAdvert.basicInfo.location.details.postcode}
      </span>
      <span className="flex items-center gap-1">
        <Building2 className="h-3 w-3" />{" "}
        {capitalizeWords(job.jobAdvert.basicInfo.industry)}
      </span>
      <span className="flex items-center gap-1">
        <Clock className="h-3 w-3" />{" "}
        {capitalizeWords(job.jobAdvert.jobDetails.jobType.value)}
      </span>
      <span className="flex items-center gap-1">
        {" "}
        <PoundSterling className="w-3 h-3" />
        {salary} {salaryFrequency}
      </span>
      <p className="text-xs text-gray-400">
        Posted on {new Date(job.createdAt).toLocaleDateString()}
      </p>
    </div>
  );
};

export default JobCard;
